module.exports = __webpack_public_path__ + "05adf4da3be9d599a2a741692279b749.pdf";